module.exports = __webpack_public_path__ + "img/tree-9-orange.0f7cc113.png";